<template>
  <div v-if="showInfoModal">
    <div class="popupModal" :class="{active: showInfoModal}">
      <div class="popupModal__wrapper">
        <div class="popupModal__content">
          <template>
            <div class="popup_buttons">
              <div class="footer-ok__btn" variant="primary" @click="onEmailClick">
                <template>Email</template>
              </div>
              <div class="footer-cancel__btn" @click="onMailClick">
                <template>Mail</template>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import errorMixin from "@/mixins/errorMixin";
import logAnalyticsEvent from "@/helpers/analytics";

export default {
  name: "PrizeDeliveryPopup",

  mixins: [mixin, errorMixin],

  data() {
    return {
      showInfoModal: this.settings !== null,
    }
  },

  watch: {
    settings(newValue) {
      this.showInfoModal = newValue !== null
    }
  },

  props: {
    settings: {
      type: [Object, null],
      default: () => {
        return {}
      }
    },
  },

  methods: {
    async onClose() {
      logAnalyticsEvent('geo_popup_close_click')
      this.showInfoModal = false
      if (this.settings.onCancelHandler) {
        try {
          await this.settings.onCancelHandler(this.settings)
        } catch (error) {
          this.showErrorModal(error.message)
        }
      }
    },
    async onEmailClick () {
      this.showInfoModal = false
      if(this.settings.onEmailHandler) {
        try {
          await this.settings.onEmailHandler(this.settings)
        } catch (error) {
          this.showErrorModal(error.message)
        }
      }
    },
    async onMailClick () {
      this.showInfoModal = false
      if(this.settings.onMailHandler) {
        try {
          await this.settings.onMailHandler(this.settings)
        } catch (error) {
          this.showErrorModal(error.message)
        }
      }
    }
  }
}
</script>

<style scoped>
    .popup_buttons {
        margin-top: 15px;
        margin-bottom: 15px;
        text-align: center;
    }
    .footer-ok__btn, .footer-cancel__btn {
        background-color: #e79922;
        color: white;
        padding: 10px;
        border-radius: 3px;
        text-transform: uppercase;
        margin-bottom: 15px;
        font-family: "Proxima Nova Light";
    }
    .footer-cancel__btn {
        margin-bottom: 0;
    }
    .popupModal__content {
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        margin: 19em auto;
    }
</style>